import React from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import { IoBusiness, IoLocationSharp, IoTime } from "react-icons/io5";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import useCommon from "hooks/useCommon";

const HotelsInfoCard = () => {
  const { STORE } = useCommon();

  const hotels = STORE((state) => state.ui.hotels);

  return (
    <Card
      sx={{
        height: "100%",
        overflow: "hidden",
        position: "relative",
        // background: "linear-gradient(135deg, rgba(34,42,90,0.95) 0%, rgba(14,22,55,0.98) 100%)",
        // border: "1px solid rgba(255,255,255,0.08)",
        // backdropFilter: "blur(20px)",
      }}
    >
      <VuiBox p={0} position="relative" zIndex={1}>
        {/* Header */}
        <VuiBox px={1} mb={2}>
          <VuiTypography variant="lg" fontWeight="medium">
            Connected Properties
          </VuiTypography>

          {/* <VuiTypography variant="caption"  fontWeight="regular" sx={{ opacity: 0.75 }}>
            Hotels linked to your workspace
          </VuiTypography> */}
        </VuiBox>

        {!hotels?.length ? (
          <VuiBox
            py={6}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <IoBusiness size={42} color="#6B7280" />

            <VuiTypography variant="button" fontWeight="regular" mt={2}>
              No hotels connected
            </VuiTypography>
          </VuiBox>
        ) : (
          <Grid container spacing={2}>
            {hotels.map((hotel, index) => (
              <Grid item xs={12} key={hotel._id || index}>
                <VuiBox
                  px={1.5}
                  py={1}
                  borderRadius="16px"
                  sx={{
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.015))",
                    border: "1px solid rgba(255,255,255,0.06)",
                    transition: "all 0.25s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      border: "1px solid rgba(34, 34, 34, 0.25)",
                      background:
                        "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
                    },
                  }}
                >
                  <VuiBox display="flex" alignItems="center" gap={1.5}>
                    {/* Icon */}
                    <VuiBox
                      width="42px"
                      height="42px"
                      borderRadius="14px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        background: "rgba(255,255,255,0.06)",
                        backdropFilter: "blur(12px)",
                        WebkitBackdropFilter: "blur(12px)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                        flexShrink: 0,
                      }}
                    >
                      <IoBusiness size={18} />
                    </VuiBox>

                    {/* Content */}
                    <VuiBox flex={1} minWidth={0}>
                      <VuiTypography
                        variant="button"
                        fontWeight="medium"
                        sx={{
                          display: "block",
                          lineHeight: 1.2,
                          mb: 1.5,
                        }}
                      >
                        {hotel?.name || "Unnamed Hotel"}
                      </VuiTypography>

                      {/* Address */}
                      <VuiBox display="flex" alignItems="center" gap={0.8} mb={0.5}>
                        <IoLocationSharp size={13} />

                        <VuiTypography
                          variant="caption"
                          fontWeight="regular"
                          sx={{
                            opacity: 0.8,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {hotel?.address || "No address available"}
                        </VuiTypography>
                      </VuiBox>

                      {/* Timezone */}
                      <VuiBox display="flex" alignItems="center" gap={0.8}>
                        <IoTime size={12} />

                        <VuiTypography
                          variant="caption"
                          fontWeight="regular"
                          sx={{ opacity: 0.75 }}
                        >
                          {hotel?.timezone || "Not specified"}
                        </VuiTypography>
                      </VuiBox>
                    </VuiBox>
                  </VuiBox>
                </VuiBox>
              </Grid>
            ))}
          </Grid>
        )}
      </VuiBox>
    </Card>
  );
};

export default HotelsInfoCard;
